/* Konteo — « La carte des poivres » (ADR 0009). Konteo-owned, no framework.
   The world is pre-projected at build time (pim/scripts/build-map-data.mjs): this file draws the
   SVG paths, places the dots, pans and zooms, flies to a place on selection, and fills the panel. */
(function () {
  var root = document.querySelector('[data-konteo-carte]');
  if (!root) return;
  var app = root.querySelector('[data-app]');
  var mq = window.matchMedia('(max-width: 860px)');
  var U, D, M; // copy, places, map geometry
  var S = { sel: null, hover: null, cluster: null, country: null, added: {}, k: 1, tx: 0, ty: 0, anim: null, sheet: 'half' };
  var byId = {}, order = [], nodes = {}, labels = {}, els = {}, raf = null, hinted = false;
  var MIN = 16;
  function maxK() { return mq.matches ? 9 : 12; }
  var panelKey = null;

  // ---------------------------------------------------------------- helpers
  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (children || []).forEach(function (c) { if (c !== null && c !== undefined && c !== false) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function svg(tag, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] !== null && attrs[k] !== undefined) el.setAttribute(k, attrs[k]); });
    return el;
  }
  function esc(s) { return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(tpl, vars) { return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) { return vars[k] === undefined || vars[k] === null ? '' : vars[k]; }); }
  function eur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function thumb(url, w) { return url ? (url.indexOf('?') === -1 ? url + '?width=' + w : url + '&width=' + w) : ''; }
  function fam(key) { return (U.families && U.families[key]) || null; }
  function mainFam(p) {
    var c = {};
    (p.pots || []).forEach(function (x) { if (x.family) c[x.family] = (c[x.family] || 0) + 1; });
    return Object.keys(c).sort(function (a, b) { return c[b] - c[a]; })[0] || null;
  }
  function colorOf(key) { var f = fam(key); return f ? f.color : '#6b6c75'; }
  function potsLabel(n) { return fmt(n > 1 ? U.pot_many : U.pot_one, { n: n }); }
  function placesLabel(n) { return fmt(n > 1 ? U.place_many : U.place_one, { n: n }); }
  function placesOfIso(iso) { return D.places.filter(function (p) { return p.iso === iso; }); }
  function minPrice(p) { var pots = p.pots.filter(function (x) { return x.format === 'pot'; }); return Math.min.apply(null, (pots.length ? pots : p.pots).map(function (x) { return x.price; })); }
  function isWorkshop(slug) { return slug === 'heusy'; }
  function track(name, data) { try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, data || {}); } catch (e) { /* no analytics */ } }
  function toast(text) { var el = h('div', { class: 'kc-toast', role: 'status' }, [text]); document.body.appendChild(el); setTimeout(function () { el.remove(); }, 2200); }
  function geo() { return mq.matches ? M.mobile : M.desktop; }
  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function setHash(v) { try { history.replaceState(null, '', location.pathname + location.search + (v ? '#lieu=' + v : '')); } catch (e) { /* no history */ } }

  // ---------------------------------------------------------------- map
  function buildMap() {
    var g = geo(), s = els.svg;
    s.innerHTML = '';
    s.setAttribute('viewBox', '0 0 ' + g.w + ' ' + g.h);
    els.gLand = svg('g', { class: 'kc-gland' });
    els.gLand.appendChild(svg('path', { class: 'kc-land', d: g.land }));
    els.hl = svg('path', { class: 'kc-hl' });
    els.gLand.appendChild(els.hl);
    // every country that has a place is a surface: hover tints it, a click opens it
    els.gCountries = svg('g', { class: 'kc-countries' });
    Object.keys(g.countries).forEach(function (iso) {
      if (iso === (D && D.workshop && D.workshop.iso) && !(D && placesOfIso(iso).length)) return;
      var c = svg('path', { class: 'kc-country', d: g.countries[iso], 'data-iso': iso });
      els.gCountries.appendChild(c);
    });
    els.gLand.appendChild(els.gCountries);
    els.gDots = svg('g');
    els.gLabels = svg('g', { 'aria-hidden': 'true' });
    s.appendChild(els.gLand); s.appendChild(els.gDots); s.appendChild(els.gLabels);
    nodes = {}; labels = {};
    S.k = 1; S.tx = 0; S.ty = 0;
    els.stage.style.setProperty('--kc-header', headerBottom() + 'px');
    applyTransform();
  }
  function clampT() {
    var g = geo(), b = g.bounds || [0, 0, g.w, g.h];
    S.tx = Math.min(40 - S.k * b[0], Math.max(g.w - S.k * b[2] - 40, S.tx));
    S.ty = Math.min(40 - S.k * Math.max(0, b[1]), Math.max(g.h - S.k * Math.min(g.h, b[3]) - 40, S.ty));
  }
  function applyTransform() {
    clampT();
    els.gLand.setAttribute('transform', 'translate(' + S.tx + ',' + S.ty + ') scale(' + S.k + ')');
    renderContext();
    els.svg.style.touchAction = S.k > 1.01 ? 'none' : 'pan-y';
    if (els.zoomIn) { els.zoomIn.disabled = S.k >= maxK() - 0.01; els.zoomOut.disabled = S.k <= 1.01; els.zoomReset.disabled = S.k <= 1.01; }
    // the region buttons are a world-view affordance: gone as soon as the map is zoomed
    if (els.regions) { els.regions.hidden = S.k > 1.01; if (S.k <= 1.01 && Math.abs(S.tx) < 1) [].forEach.call(els.regions.children, function (c) { c.classList.toggle('is-on', c.dataset.view === 'home'); }); }
  }
  function base(slug) { return geo().points[slug]; }
  function pt(slug) { var p = base(slug); return [S.k * p[0] + S.tx, S.k * p[1] + S.ty]; }
  function svgPoint(e) {
    var m = els.svg.getScreenCTM();
    if (!m) return [0, 0];
    var p = new DOMPoint(e.clientX, e.clientY).matrixTransform(m.inverse());
    return [p.x, p.y];
  }
  function scheduleDots() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; renderDots(); }); }

  // A view change is a short tween (cubic-out), or a jump under prefers-reduced-motion.
  function setView(k, tx, ty, animate, done) {
    k = Math.min(maxK(), Math.max(1, k));
    if (S.anim) { cancelAnimationFrame(S.anim); S.anim = null; }
    if (!animate || reduceMotion()) { S.k = k; S.tx = tx; S.ty = ty; applyTransform(); renderDots(); if (done) done(); return; }
    var from = { k: S.k, tx: S.tx, ty: S.ty }, t0 = performance.now(), dur = 360;
    (function step(now) {
      var t = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - t, 3);
      S.k = from.k + (k - from.k) * e; S.tx = from.tx + (tx - from.tx) * e; S.ty = from.ty + (ty - from.ty) * e;
      applyTransform(); renderDots();
      if (t < 1) S.anim = requestAnimationFrame(step); else { S.anim = null; if (done) done(); }
    })(t0);
  }
  // A view far from the current one is reached through the world: out, then in, so the visitor keeps their bearings.
  function travel(k, tx, ty) {
    var g = geo();
    var cx = (g.w / 2 - tx) / k, cy = (g.h / 2 - ty) / k; // target centre in base units
    var sx = S.k * cx + S.tx, sy = S.k * cy + S.ty; // where that point sits on screen now
    var visible = sx > 0 && sx < g.w && sy > 0 && sy < g.h;
    if (S.k > 2 && !visible) setView(1, 0, 0, true, function () { setView(k, tx, ty, true); });
    else setView(k, tx, ty, true);
  }
  function headerBottom() { var hd = document.querySelector('.site-header, header'); if (!hd) return 0; var r = hd.getBoundingClientRect(); return getComputedStyle(hd).position === 'sticky' || getComputedStyle(hd).position === 'fixed' || r.top <= 0 ? Math.max(0, r.bottom) : 0; }
  // Where a selected place lands: the centre on desktop; on mobile the middle of the strip of map
  // left visible between the site header and the half-open sheet, once the page has scrolled to the map.
  function focusPoint() {
    var g = geo();
    if (!mq.matches) return [g.w / 2, g.h / 2];
    var r = els.svg.getBoundingClientRect(), vis = Math.max(120, window.innerHeight * 0.42 - headerBottom());
    return [g.w / 2, Math.min(g.h * 0.8, vis * 0.5 * g.h / Math.max(1, r.height))];
  }
  function scrollToMap() {
    if (!mq.matches) return;
    var r = els.svg.getBoundingClientRect(), y = window.scrollY + r.top - headerBottom();
    if (Math.abs(r.top - headerBottom()) < 8) return;
    // an instant jump: the sheet opens at the same moment and the map must already sit under the header
    window.scrollTo(0, Math.max(0, y));
  }
  function zoomAround(k, cx, cy, animate) {
    k = Math.min(maxK(), Math.max(1, k));
    var px = (cx - S.tx) / S.k, py = (cy - S.ty) / S.k;
    setView(k, cx - px * k, cy - py * k, animate);
  }
  function nearest(slug) {
    var b = base(slug), best = Infinity;
    D.places.forEach(function (p) { if (p.slug === slug) return; var q = base(p.slug); var d = Math.hypot(q[0] - b[0], q[1] - b[1]); if (d < best) best = d; });
    return best;
  }
  function flyTo(slug) {
    var p = byId[slug], level = isWorkshop(slug) ? 'atelier' : p.level;
    // the level's zoom, raised until the nearest neighbour sits clear of the ring, kept if the visitor is already close to it
    var k = (U.zoom_by_level || {})[level] || 3;
    // a country or a region keeps its view: the raise for a close terroir is capped at twice the level's zoom
    if (!isWorkshop(slug)) k = Math.max(k, Math.min(level === 'terroir' ? maxK() : k * 2, 28 / Math.max(0.5, nearest(slug))));
    k = Math.min(maxK(), Math.max(1, k));
    if (S.k > k / 1.6 && S.k < k * 1.6) k = S.k;
    var b = base(slug), f = focusPoint();
    travel(k, f[0] - k * b[0], f[1] - k * b[1]);
  }
  function flyToBox(x0, y0, x1, y1) {
    var g = geo(), f = focusPoint(), pad = 1.3;
    var k = Math.min(maxK(), Math.max(1, Math.min(g.w / ((x1 - x0) * pad), (mq.matches ? g.h * 0.5 : g.h) / ((y1 - y0) * pad))));
    var cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
    travel(k, f[0] - k * cx, f[1] - k * cy);
  }
  function regionView(view) {
    var g = geo();
    if (view === 'americas' && g.bounds) setView(1, -g.bounds[0] + 8, 0, true); else setView(1, 0, 0, true);
  }
  function renderContext() {
    if (!els.maphint || !D) return;
    var p = S.sel && byId[S.sel], c = S.country;
    els.maphint.textContent = (!mq.matches && S.k >= 4 && (p || c)) ? fmt(U.context_line, { country: p ? p.country : c.name, continent: p ? p.continent : c.continent }) : '';
  }
  function flyToGroup(places) {
    var xs = places.map(function (p) { return base(p.slug)[0]; }), ys = places.map(function (p) { return base(p.slug)[1]; });
    var spread = Math.max(Math.max.apply(null, xs) - Math.min.apply(null, xs), Math.max.apply(null, ys) - Math.min.apply(null, ys), 0.01);
    var k = Math.min(maxK(), Math.max(S.k * 1.6, 48 / spread)), f = focusPoint();
    var cx = (Math.max.apply(null, xs) + Math.min.apply(null, xs)) / 2, cy = (Math.max.apply(null, ys) + Math.min.apply(null, ys)) / 2;
    travel(k, f[0] - k * cx, f[1] - k * cy);
  }

  // Dots never move. Dots closer than 16 units at the current zoom form one pill with a count.
  function layout() {
    var g = geo();
    var pts = D.places.map(function (p) { var xy = pt(p.slug); return { p: p, x: xy[0], y: xy[1] }; })
      .filter(function (d) { return d.x > -30 && d.x < g.w + 30 && d.y > -30 && d.y < g.h + 30; });
    // the selected place and the busiest ones (three pots or more) always keep their own dot
    var groups = [], out = [];
    pts.forEach(function (d) {
      if (d.p.slug === S.sel || d.p.pots.length >= 3) { d.type = 'dot'; out.push(d); return; }
      var grp = null;
      for (var i = 0; i < groups.length && !grp; i++) if (groups[i].some(function (m) { return Math.hypot(m.x - d.x, m.y - d.y) < MIN; })) grp = groups[i];
      if (grp) grp.push(d); else groups.push([d]);
    });
    groups.forEach(function (grp) {
      if (!grp.length) return;
      if (grp.length === 1) { grp[0].type = 'dot'; out.push(grp[0]); return; }
      var c = {};
      grp.forEach(function (m) { m.p.pots.forEach(function (x) { if (x.family) c[x.family] = (c[x.family] || 0) + 1; }); });
      out.push({ type: 'cluster', x: grp.reduce(function (s, m) { return s + m.x; }, 0) / grp.length, y: grp.reduce(function (s, m) { return s + m.y; }, 0) / grp.length, m: grp.map(function (m) { return m.p; }), count: grp.length, fam: Object.keys(c).sort(function (a, b) { return c[b] - c[a]; })[0] || null, key: 'c:' + grp.map(function (m) { return m.p.slug; }).join('|') });
    });
    var w = pt('heusy');
    out.push({ type: 'workshop', x: w[0], y: w[1], slug: 'heusy' });
    // a fixed order (the index order, the workshop last): the tab order never shuffles
    var rank = function (d) { return d.type === 'workshop' ? 9999 : d.type === 'cluster' ? Math.min.apply(null, d.m.map(function (p) { return order.indexOf(p.slug); })) : order.indexOf(d.p.slug); };
    out.sort(function (a, b) { return rank(a) - rank(b); });
    return out;
  }
  function makeNode(type) {
    var a = svg('a', { class: 'kc-pt kc-pt--' + type });
    a.appendChild(svg('circle', { class: 'kc-hit', r: mq.matches ? 22 : 14 }));
    if (type === 'workshop') a.appendChild(svg('rect', { class: 'kc-sq', x: -5, y: -5, width: 10, height: 10 }));
    else { a.appendChild(svg('circle', { class: 'kc-ring', r: 0 })); a.appendChild(svg('circle', { class: 'kc-dot', r: 0 })); }
    a.appendChild(svg('text', { class: 'kc-cnt', y: 4 }));
    return a;
  }
  function renderDots() {
    if (!M || !D) return;
    var g = geo(), items = layout(), seen = {};
    var keyOf = function (d) { return d.type === 'cluster' ? d.key : d.type === 'workshop' ? 'heusy' : d.p.slug; };
    var isSel = function (d) { return (d.type === 'dot' && d.p.slug === S.sel) || (d.type === 'workshop' && S.sel === 'heusy'); };
    var isHover = function (d) { return d.type === 'dot' && d.p.slug === S.hover; };
    var radius = function (d) { return d.type === 'cluster' ? 9 : (isSel(d) ? 8 : (isHover(d) ? 7 : 6)); };
    // dots, in the fixed order
    items.forEach(function (d) {
      var key = keyOf(d), a = nodes[key] || (nodes[key] = makeNode(d.type));
      seen[key] = true;
      a.__d = d;
      var R = radius(d), sel = isSel(d);
      a.setAttribute('transform', 'translate(' + d.x + ',' + d.y + ')');
      a.setAttribute('href', d.type === 'cluster' ? '#' : '#lieu=' + (d.type === 'workshop' ? 'heusy' : d.p.slug));
      a.setAttribute('aria-label', d.type === 'cluster' ? fmt(U.cluster_aria, { n: d.count }) : d.type === 'workshop' ? U.workshop_label : fmt(U.dot_aria, { name: d.p.name, country: d.p.country, pots: potsLabel(d.p.pots.length) }));
      a.classList.toggle('is-selected', sel);
      if (d.type !== 'workshop') {
        var dot = a.querySelector('.kc-dot'); dot.setAttribute('r', R); dot.setAttribute('fill', colorOf(d.type === 'cluster' ? d.fam : mainFam(d.p)));
        a.querySelector('.kc-ring').setAttribute('r', sel ? 12 : (a === document.activeElement ? 10 : 0));
      }
      a.querySelector('.kc-cnt').textContent = d.type === 'cluster' ? d.count : '';
      els.gDots.appendChild(a);
    });
    Object.keys(nodes).forEach(function (k) { if (!seen[k]) { nodes[k].remove(); delete nodes[k]; } });
    // labels, in their own layer: the selected and hovered ones are placed first and drawn last
    var wanted = [];
    items.forEach(function (d) {
      var text = '';
      if (d.type === 'workshop') text = U.workshop_label;
      else if (d.type === 'dot' && (isSel(d) || isHover(d) || (!mq.matches && (d.p.pots.length >= 3 || S.k >= 2.5)))) text = d.p.name;
      if (text) wanted.push({ d: d, text: text, prio: (isSel(d) || isHover(d)) ? 0 : 1 });
    });
    wanted.sort(function (a, b) { return a.prio - b.prio; });
    var boxes = [], placed = [], lseen = {};
    wanted.forEach(function (w) {
      var d = w.d, R = radius(d), est = w.text.length * 7.2 + R + 10, right = d.x + est < g.w - 6;
      var box = { x0: right ? d.x : d.x - est, x1: right ? d.x + est : d.x, y0: d.y - 8, y1: d.y + 8 };
      if (w.prio === 1 && boxes.some(function (b) { return !(box.x1 < b.x0 || box.x0 > b.x1 || box.y1 < b.y0 || box.y0 > b.y1); })) return;
      boxes.push(box);
      placed.push({ key: keyOf(d), d: d, text: w.text, R: R, right: right, prio: w.prio });
    });
    placed.sort(function (a, b) { return b.prio - a.prio; });
    placed.forEach(function (w) {
      var t = labels[w.key] || (labels[w.key] = svg('text', { class: 'kc-lbl' + (w.d.type === 'workshop' ? ' kc-lbl--workshop' : ''), y: 4.5 }));
      lseen[w.key] = true;
      t.textContent = w.text;
      t.setAttribute('transform', 'translate(' + w.d.x + ',' + w.d.y + ')');
      t.setAttribute('x', w.right ? w.R + 7 : -(w.R + 7));
      t.setAttribute('text-anchor', w.right ? 'start' : 'end');
      els.gLabels.appendChild(t);
    });
    Object.keys(labels).forEach(function (k) { if (!lseen[k]) { labels[k].remove(); delete labels[k]; } });
  }
  function renderCountry() {
    if (!M) return;
    var iso = S.country ? S.country.iso : S.sel ? (isWorkshop(S.sel) ? D.workshop.iso : byId[S.sel] && byId[S.sel].iso) : null;
    var d = iso ? geo().countries[iso] : null;
    if (d) els.hl.setAttribute('d', d); else els.hl.removeAttribute('d');
    [].forEach.call(els.gCountries ? els.gCountries.children : [], function (c) { c.classList.toggle('is-on', c.dataset.iso === iso); });
  }

  function select(slug, opts) {
    if (!byId[slug] && !isWorkshop(slug)) return;
    S.sel = slug; S.cluster = null; S.country = null; S.hover = null;
    scrollToMap();
    requestAnimationFrame(function () { els.stage.style.setProperty('--kc-header', headerBottom() + 'px'); });
    if (M) flyTo(slug);
    if (!(opts && opts.silent)) { track('carte_select', { place: slug }); setHash(slug); }
    if (mq.matches) setSheet('half');
    els.live.textContent = isWorkshop(slug) ? U.workshop_label : fmt(U.live_selected, { name: byId[slug].name, country: byId[slug].country, pots: potsLabel(byId[slug].pots.length) });
  }
  function toIndex() { S.sel = null; S.cluster = null; S.country = null; setHash(''); renderAll(); }
  // A country: its own place when one exists at country level, otherwise a view of all its places.
  function selectCountry(iso) {
    var list = placesOfIso(iso);
    if (!list.length) return;
    var own = list.filter(function (p) { return p.level === 'pays'; })[0];
    if (own && list.length === 1) { select(own.slug); renderAll(); return; }
    S.country = { iso: iso, name: list[0].country, continent: list[0].continent, places: list };
    S.sel = null; S.cluster = null; S.hover = null;
    scrollToMap();
    var el = els.gCountries.querySelector('[data-iso="' + iso + '"]');
    if (el) { var bb = el.getBBox(); flyToBox(bb.x, bb.y, bb.x + bb.width, bb.y + bb.height); }
    if (mq.matches) setSheet('half');
    track('carte_country', { country: list[0].country });
    setHash('');
    els.live.textContent = list[0].country + ', ' + placesLabel(list.length);
    renderAll();
  }
  function pick(d) {
    if (d.type === 'cluster') { S.cluster = d.m; S.sel = null; S.country = null; scrollToMap(); flyToGroup(d.m); if (mq.matches) setSheet('half'); renderAll(); return; }
    select(d.type === 'workshop' ? 'heusy' : d.p.slug); renderAll();
  }

  // ---------------------------------------------------------------- pan and zoom
  function wheelHint() {
    if (hinted) return;
    hinted = true;
    els.hint.textContent = U.wheel_hint; els.hint.classList.add('is-on');
    setTimeout(function () { els.hint.classList.remove('is-on'); }, 1600);
  }
  function bindMap() {
    var s = els.svg, pointers = {}, start = null, moved = false, pinch = null;
    s.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointers[e.pointerId] = svgPoint(e);
      var ids = Object.keys(pointers);
      // no pointer capture yet: capturing on pointerdown retargets the click to the svg itself and kills clicks on dots and countries
      if (ids.length === 1) { start = { x: pointers[e.pointerId][0], y: pointers[e.pointerId][1], cx: e.clientX, cy: e.clientY, tx: S.tx, ty: S.ty, type: e.pointerType, id: e.pointerId }; moved = false; }
      else if (ids.length === 2) { var a = pointers[ids[0]], b = pointers[ids[1]]; pinch = { d: Math.hypot(a[0] - b[0], a[1] - b[1]), k: S.k, cx: (a[0] + b[0]) / 2, cy: (a[1] + b[1]) / 2, px: ((a[0] + b[0]) / 2 - S.tx) / S.k, py: ((a[1] + b[1]) / 2 - S.ty) / S.k }; }
    });
    s.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = svgPoint(e);
      var ids = Object.keys(pointers);
      if (ids.length === 2 && pinch) {
        var a = pointers[ids[0]], b = pointers[ids[1]], d = Math.hypot(a[0] - b[0], a[1] - b[1]);
        S.k = Math.min(maxK(), Math.max(1, pinch.k * d / Math.max(1, pinch.d)));
        S.tx = pinch.cx - pinch.px * S.k; S.ty = pinch.cy - pinch.py * S.k;
        applyTransform(); scheduleDots(); moved = true;
      } else if (start && (start.type === 'mouse' || S.k > 1.01)) {
        var dx = pointers[e.pointerId][0] - start.x, dy = pointers[e.pointerId][1] - start.y;
        if (!moved && Math.hypot(e.clientX - start.cx, e.clientY - start.cy) > 6) { moved = true; s.classList.add('is-dragging'); try { s.setPointerCapture(e.pointerId); } catch (err) { /* no capture */ } }
        if (moved) { S.tx = start.tx + dx; S.ty = start.ty + dy; applyTransform(); scheduleDots(); }
      }
    });
    function up(e) {
      delete pointers[e.pointerId];
      var ids = Object.keys(pointers);
      if (!ids.length) { start = null; pinch = null; s.classList.remove('is-dragging'); setTimeout(function () { moved = false; }, 0); }
      else if (ids.length === 1) { pinch = null; start = { x: pointers[ids[0]][0], y: pointers[ids[0]][1], tx: S.tx, ty: S.ty, type: 'touch' }; }
    }
    s.addEventListener('pointerup', up); s.addEventListener('pointercancel', up);
    s.addEventListener('wheel', function (e) {
      if (!(e.ctrlKey || e.metaKey)) { wheelHint(); return; } // plain wheel scrolls the page
      e.preventDefault();
      var dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * 400 : e.deltaY;
      var f = Math.min(1.18, Math.max(0.85, Math.exp(-dy * 0.0015))), c = svgPoint(e);
      zoomAround(S.k * f, c[0], c[1], false);
    }, { passive: false });
    s.addEventListener('click', function (e) {
      var a = e.target.closest('.kc-pt');
      if (a) e.preventDefault();
      if (moved) { moved = false; return; }
      if (a && a.__d) { pick(a.__d); return; }
      var c = e.target.closest('.kc-country');
      if (c) selectCountry(c.dataset.iso);
    });
    s.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); toIndex(); return; }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var cur = S.sel && !isWorkshop(S.sel) ? order.indexOf(S.sel) : -1;
        var next = order[(cur + (e.key === 'ArrowRight' ? 1 : order.length - 1)) % order.length];
        select(next); renderAll();
        var n = nodes[next]; if (n) n.focus();
      }
    });
    s.addEventListener('focusin', function (e) { var a = e.target.closest('.kc-pt'); var r = a && a.querySelector('.kc-ring'); if (r && !a.classList.contains('is-selected')) r.setAttribute('r', 10); });
    s.addEventListener('focusout', function (e) { var a = e.target.closest('.kc-pt'); var r = a && a.querySelector('.kc-ring'); if (r && !a.classList.contains('is-selected')) r.setAttribute('r', 0); });
    s.addEventListener('mouseover', function (e) {
      var a = e.target.closest('.kc-pt');
      if (!a || !a.__d || mq.matches || a.__d.type !== 'dot') return;
      if (S.hover !== a.__d.p.slug) { S.hover = a.__d.p.slug; renderDots(); }
    });
    s.addEventListener('mouseout', function (e) {
      var a = e.target.closest('.kc-pt');
      if (a && S.hover && (!e.relatedTarget || !a.contains(e.relatedTarget))) { S.hover = null; renderDots(); }
    });
    els.zoomIn.addEventListener('click', function () { var f = focusPoint(); zoomAround(S.k * 1.6, f[0], f[1], true); });
    els.zoomOut.addEventListener('click', function () { var f = focusPoint(); zoomAround(S.k / 1.6, f[0], f[1], true); });
    els.zoomReset.addEventListener('click', function () { setView(1, 0, 0, true); });
    els.regions.addEventListener('click', function (e) { var b = e.target.closest('[data-view]'); if (!b) return; regionView(b.dataset.view); [].forEach.call(els.regions.children, function (c) { c.classList.toggle('is-on', c === b); }); });
  }

  // ---------------------------------------------------------------- panel
  function placeRow(p, top, inCountry) {
    var mf = mainFam(p);
    // under the name: the country, or inside a country view the kind of place; the busiest places add their family phrase
    var sub = inCountry ? (p.level === 'pays' ? U.country_eyebrow : (U.levels[p.level] || p.level).split(',')[0]) : p.country;
    if (top && mf && fam(mf)) sub += ', ' + fam(mf).phrase.charAt(0).toLowerCase() + fam(mf).phrase.slice(1);
    return '<button class="kc-pl' + (top ? ' is-top' : '') + '" type="button" data-place="' + esc(p.slug) + '">'
      + '<span class="kc-pl-main"><span class="kc-pl-name">' + esc(p.name) + '</span><span class="kc-pl-sub">' + esc(sub) + '</span></span>'
      + '<b>' + esc(fmt(U.index_from, { pots: potsLabel(p.pots.length), price: eur(minPrice(p)) })) + '<i style="background:' + colorOf(mf) + '"></i></b></button>';
  }
  function workshopRow() {
    return '<button class="kc-pl kc-pl--workshop" type="button" data-place="heusy"><span class="kc-pl-main"><span class="kc-pl-name">' + esc(U.workshop_name) + '</span><span class="kc-pl-sub">' + esc(U.workshop_index) + '</span></span><b><i class="kc-sqi"></i></b></button>';
  }
  function potRow(x, place) {
    var key = String(x.variant_id), f = fam(x.family);
    var meta = x.weight ? fmt(U.format_weight, { format: U.formats[x.format] || x.format, g: x.weight }) : (U.formats[x.format] || x.format);
    if (place) meta += ', ' + place.name;
    var right = !x.available ? '<span class="kc-oos">' + esc(U.out_of_stock) + '</span>'
      : '<button class="kc-add' + (S.added[key] ? ' is-ok' : '') + '" type="button" data-add="' + key + '"' + (S.added[key] ? ' disabled' : '') + '>' + esc(S.added[key] ? U.added : U.add) + '</button>';
    return '<div class="kc-prow' + (x.available ? '' : ' is-oos') + '" data-row="' + key + '">'
      + '<img src="' + esc(thumb(x.image, 160)) + '" alt="" width="56" height="56" loading="lazy">'
      + '<div><div class="kc-nm"><a href="' + esc(x.url) + '">' + esc(x.short || x.title) + '</a></div>'
      + '<div class="kc-tag">' + esc(meta) + '<i style="background:' + (f ? f.color : '#6b6c75') + '"></i>' + esc(f ? f.label : U.family_none) + '</div></div>'
      + '<div class="kc-right"><span class="kc-pr">' + eur(x.price) + '</span>' + right + '</div></div>';
  }
  // The bundle: one pot per title, pot format first, the cheapest ones, two or three of them.
  function bundleOf(p) {
    var seen = {}, list = [], pots = p.pots.filter(function (x) { return x.format === 'pot' && x.available; });
    (pots.length >= 2 ? pots : p.pots.filter(function (x) { return x.available; })).slice().sort(function (a, b) { return a.price - b.price; })
      .forEach(function (x) { if (!seen[x.short]) { seen[x.short] = true; list.push(x); } });
    list = list.slice(0, 3);
    if (list.length < 2) return null;
    var colours = Object.keys(U.colours || {}).filter(function (c) { return list.some(function (x) { return new RegExp('\\b' + U.colours[c] + '\\b', 'i').test(x.short); }); });
    var total = list.reduce(function (a, x) { return a + x.price; }, 0);
    var label = colours.length === list.length ? fmt(U.bundle_colours, { n: list.length, place: p.name, total: eur(total) }) : fmt(list.length === 3 ? U.bundle_trio : U.bundle_duo, { place: p.name, total: eur(total) });
    return { pots: list, label: label, total: total };
  }
  function indexOrder() {
    var out = [];
    U.continents.forEach(function (c) { D.places.filter(function (p) { return p.continent === c; }).forEach(function (p) { out.push(p.slug); }); });
    return out;
  }
  function renderPanel() {
    var html = '', foot = '';
    if (S.cluster) {
      var cs = []; S.cluster.forEach(function (p) { if (cs.indexOf(p.country) === -1) cs.push(p.country); });
      var title = cs.length > 1 ? cs.slice(0, -1).join(', ') + ' et ' + cs[cs.length - 1] : cs[0];
      html = '<div class="kc-eyebrow">' + esc(fmt(U.cluster_eyebrow, { n: S.cluster.length })) + '</div><h2 class="kc-h2">' + esc(title) + '</h2><p class="kc-hint">' + esc(U.cluster_hint) + '</p><div class="kc-idx"><div class="kc-cont">' + S.cluster.map(function (p) { return placeRow(p, false); }).join('') + '</div></div>';
      foot = '<button type="button" data-nav="index">' + esc(U.all_places) + '</button>';
    } else if (S.country) {
      var cn = S.country, cpots = cn.places.reduce(function (n, p) { return n + p.pots.length; }, 0);
      html = '<div class="kc-eyebrow">' + esc(U.country_eyebrow) + '</div><h2 class="kc-h2">' + esc(cn.name) + '</h2>'
        + '<p class="kc-story">' + esc(fmt(U.country_line, { places: placesLabel(cn.places.length), pots: potsLabel(cpots) })) + '</p>'
        + '<div class="kc-idx"><div class="kc-cont"><div class="kc-eyebrow">' + esc(U.country_places) + '</div>' + cn.places.map(function (p) { return placeRow(p, false, true); }).join('') + '</div></div>'
        + '<div class="kc-eyebrow">' + esc(U.country_pots) + '</div><div class="kc-rows">' + cn.places.map(function (p) { return p.pots.map(function (x) { return potRow(x, cn.places.length > 1 ? p : null); }).join(''); }).join('') + '</div>';
      foot = '<button type="button" data-nav="index">' + esc(U.all_places) + '</button>';
    } else if (S.sel === 'heusy') {
      html = '<div class="kc-eyebrow">' + esc(U.workshop_eyebrow) + '</div><h2 class="kc-h2">' + esc(U.workshop_name) + '</h2><p class="kc-story">' + esc(U.workshop_story) + '</p>';
      foot = '<button type="button" data-nav="index">' + esc(U.all_places) + '</button><button type="button" data-nav="' + esc(order[0]) + '">' + esc(fmt(U.next_place, { name: byId[order[0]].name })) + '</button>';
    } else if (S.sel && byId[S.sel]) {
      var p = byId[S.sel], mf = mainFam(p), b = bundleOf(p);
      var eyebrow = fmt(U.levels[p.level] || p.level, { country: p.country });
      var story = p.story || (mf && fam(mf) ? fmt(U.story_fallback, { pots: potsLabel(p.pots.length), phrase: fam(mf).phrase }) : fmt(U.story_fallback_nofamily, { pots: potsLabel(p.pots.length) }));
      html = '<div class="kc-eyebrow">' + esc(eyebrow) + '</div><h2 class="kc-h2">' + esc(p.name) + '</h2>'
        + '<p class="kc-story">' + esc(story) + '</p>'
        + '<div class="kc-rows">' + p.pots.map(function (x) { return potRow(x, null); }).join('') + '</div>'
        + (b ? '<div class="kc-bundle"><button class="kc-btn' + (S.added['all:' + p.slug] ? ' is-ok' : '') + '" type="button" data-bulk="' + esc(p.slug) + '"' + (S.added['all:' + p.slug] ? ' disabled' : '') + '>' + esc(S.added['all:' + p.slug] ? fmt(U.bundle_added, { n: b.pots.length }) : b.label) + '</button><p class="kc-hint">' + esc(U.shipping) + '</p></div>' : '')
        ;
      var i = order.indexOf(p.slug), next = order[(i + 1) % order.length];
      foot = '<button type="button" data-nav="index">' + esc(U.all_places) + '</button><button type="button" data-nav="' + esc(next) + '">' + esc(fmt(U.next_place, { name: byId[next].name })) + '</button>';
    } else {
      html = '<div class="kc-eyebrow">' + esc(U.index_eyebrow) + '</div><h2 class="kc-h2">' + esc(U.index_title) + '</h2><p class="kc-hint">' + esc(U.index_hint) + '</p><div class="kc-idx">'
        + U.continents.map(function (c) {
          var list = D.places.filter(function (p) { return p.continent === c; });
          return list.length ? '<div class="kc-cont"><div class="kc-eyebrow">' + esc(c) + '</div>' + list.map(function (p) { return placeRow(p, order.indexOf(p.slug) < 3); }).join('') + '</div>' : '';
        }).join('') + '<div class="kc-cont"><div class="kc-eyebrow">' + esc(U.workshop_eyebrow) + '</div>' + workshopRow() + '</div></div>';
      foot = '<a href="' + esc(U.quiz_url) + '">' + esc(U.index_quiz) + '</a>';
    }
    els.panin.innerHTML = html; els.panfoot.innerHTML = foot;
    var key = S.cluster ? 'cluster' : S.country ? 'country:' + S.country.iso : (S.sel || 'index');
    if (key !== panelKey && els.pan.scrollTo) els.pan.scrollTo(0, 0);
    panelKey = key;
  }
  function renderLegend() {
    // a legend, nothing more: the colour of a dot is its dominant family
    els.leg.innerHTML = Object.keys(U.families).map(function (k) {
      var f = U.families[k];
      return '<span class="kc-chip" title="' + esc(f.phrase) + '"><i style="background:' + f.color + '"></i>' + esc(f.label) + '</span>';
    }).join('');
  }
  function renderAll() { renderLegend(); renderPanel(); renderCountry(); renderDots(); renderContext(); }

  // ---------------------------------------------------------------- sheet (mobile)
  function setSheet(state) {
    S.sheet = state;
    els.pan.classList.remove('is-peek', 'is-half', 'is-full');
    els.pan.classList.add('is-' + state);
    els.pan.style.height = '';
  }
  function bindSheet() {
    var y0 = null, h0 = 0;
    function down(e) { if (!mq.matches) return; y0 = e.clientY; h0 = els.pan.getBoundingClientRect().height; els.pan.classList.add('is-dragging'); e.currentTarget.setPointerCapture(e.pointerId); }
    function move(e) { if (y0 === null) return; var hgt = Math.max(80, Math.min(window.innerHeight * 0.9, h0 - (e.clientY - y0))); els.pan.style.height = hgt + 'px'; }
    function upf(e) {
      if (y0 === null) return;
      var hgt = els.pan.getBoundingClientRect().height, vh = window.innerHeight;
      var snaps = [{ s: 'peek', v: 112 }, { s: 'half', v: vh * 0.58 }, { s: 'full', v: vh * 0.85 }];
      snaps.sort(function (a, b) { return Math.abs(a.v - hgt) - Math.abs(b.v - hgt); });
      els.pan.classList.remove('is-dragging');
      setSheet(snaps[0].s); y0 = null;
    }
    [els.handle, els.sheetHead].forEach(function (el) { el.addEventListener('pointerdown', down); el.addEventListener('pointermove', move); el.addEventListener('pointerup', upf); el.addEventListener('pointercancel', upf); });
    els.close.addEventListener('click', function () { toIndex(); setSheet('peek'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { els.pan.classList.toggle('is-away', !entries[0].isIntersecting); }, { threshold: 0.05 }).observe(els.stage);
    }
  }

  // ---------------------------------------------------------------- cart
  function addToCart(variantIds, keys, btn, bundle) {
    if (btn) btn.disabled = true;
    var body = { items: variantIds.map(function (v) { return { id: v, quantity: 1 }; }), sections: 'cart-ajax' };
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) throw new Error(data.description || data.message || 'cart');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: btn || null } }));
        keys.forEach(function (k) { S.added[k] = true; });
        track('carte_add_to_cart', { source: 'carte', place: S.sel, items: variantIds.length, bundle: !!bundle });
        // patch in place: the panel keeps its scroll position
        keys.forEach(function (k) {
          var b = els.panin.querySelector('[data-add="' + k + '"]');
          if (b) { b.classList.add('is-ok'); b.disabled = true; b.textContent = U.added; }
        });
        if (btn && btn.hasAttribute('data-bulk')) { btn.classList.add('is-ok'); btn.textContent = fmt(U.bundle_added, { n: variantIds.length }); }
        if (!els.panin.querySelector('.kc-viewcart')) {
          var anchor = els.panin.querySelector('.kc-bundle') || els.panin.querySelector('.kc-rows');
          if (anchor) anchor.insertAdjacentHTML('afterend', '<a class="kc-link kc-viewcart" href="' + esc(U.cart_url) + '" data-viewcart>' + esc(U.view_cart) + '</a>');
        }
      })
      .catch(function () { toast(U.cart_error); if (btn) btn.disabled = false; });
  }

  // ---------------------------------------------------------------- build
  function buildShell() {
    els.leg = h('div', { class: 'kc-leg', role: 'list', 'aria-label': U.legend_aria });
    els.svg = svg('svg', { class: 'kc-map', role: 'group', 'aria-label': U.map_aria, preserveAspectRatio: 'xMidYMid meet' });
    els.maphint = h('div', { class: 'kc-maphint' });
    els.hint = h('div', { class: 'kc-wheelhint', 'aria-hidden': 'true' });
    els.zoomIn = h('button', { class: 'kc-zoom', type: 'button', 'aria-label': U.zoom_in }, ['+']);
    els.zoomOut = h('button', { class: 'kc-zoom', type: 'button', 'aria-label': U.zoom_out }, ['−']);
    els.zoomReset = h('button', { class: 'kc-zoom kc-zoom--reset', type: 'button' }, [U.zoom_reset]);
    els.regions = h('div', { class: 'kc-regions' }, (U.regions || []).map(function (r, i) { return h('button', { class: 'kc-region' + (r.view === 'home' ? ' is-on' : ''), type: 'button', 'data-view': r.view }, [r.label]); }));
    els.live = h('div', { class: 'kc-visually-hidden', 'aria-live': 'polite' });
    els.panin = h('div', { class: 'kc-pan-in' });
    els.panfoot = h('div', { class: 'kc-pan-foot' });
    els.handle = h('div', { class: 'kc-handle', 'aria-hidden': 'true' }, [h('span')]);
    els.close = h('button', { class: 'kc-close', type: 'button', 'aria-label': U.close }, ['×']);
    els.sheetHead = h('div', { class: 'kc-sheethead' }, [els.handle, els.close]);
    els.pan = h('aside', { class: 'kc-pan is-half' }, [els.sheetHead, els.panin, els.panfoot]);
    els.eyebrow = h('div', { class: 'kc-eyebrow' }, [fmt(U.eyebrow, { n: '…' })]);
    els.intro = h('p', { class: 'kc-intro' });
    els.stage = h('section', { class: 'kc-stage' }, [h('div', { class: 'kc-mapbox' }, [els.svg, els.maphint, els.hint, els.regions, h('div', { class: 'kc-zooms' }, [els.zoomIn, els.zoomOut, els.zoomReset])]), els.pan]);
    app.appendChild(h('section', { class: 'kc-head' }, [h('div', { class: 'kc-head-row' }, [
      h('div', null, [els.eyebrow, h('h1', { class: 'kc-title' }, [U.title]), els.intro]),
      h('div', { class: 'kc-legwrap' }, [els.leg])
    ])]));
    app.appendChild(els.stage);
    app.appendChild(els.live);
  }
  function bindShell() {
    els.pan.addEventListener('click', function (e) {
      var pl = e.target.closest('[data-place]'); if (pl) { select(pl.dataset.place); renderAll(); return; }
      var nav = e.target.closest('[data-nav]'); if (nav) { if (nav.dataset.nav === 'index') toIndex(); else { select(nav.dataset.nav); renderAll(); } return; }
      var vc = e.target.closest('[data-viewcart]'); if (vc) { var trig = document.querySelector('toggle-cart a[href$="/cart"], header-toggle-cart a[href$="/cart"]'); if (trig) { e.preventDefault(); trig.click(); } return; }
      var add = e.target.closest('[data-add]'); if (add) { addToCart([Number(add.dataset.add)], [add.dataset.add], add, false); return; }
      var bulk = e.target.closest('[data-bulk]'); if (bulk) { var b = bundleOf(byId[bulk.dataset.bulk]); if (!b) return; var fresh = b.pots.filter(function (x) { return !S.added[String(x.variant_id)]; }); addToCart(fresh.map(function (x) { return x.variant_id; }), fresh.map(function (x) { return String(x.variant_id); }).concat(['all:' + bulk.dataset.bulk]), bulk, true); }
    });
    els.pan.addEventListener('mouseover', function (e) { var pl = e.target.closest('[data-place]'); if (pl && !mq.matches && pl.dataset.place !== 'heusy' && S.hover !== pl.dataset.place) { S.hover = pl.dataset.place; renderDots(); } });
    els.pan.addEventListener('mouseout', function (e) { var pl = e.target.closest('[data-place]'); if (pl && S.hover) { S.hover = null; renderDots(); } });
    bindMap();
    bindSheet();
    var onChange = function () { setSheet('half'); buildMap(); renderAll(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
  }
  function start() {
    D.places.forEach(function (p) { byId[p.slug] = p; });
    order = indexOrder();
    var n = D.places.length, m = D.places.reduce(function (a, p) { return a + p.pots.length; }, 0);
    els.eyebrow.textContent = fmt(U.eyebrow, { n: n });
    els.intro.textContent = fmt(U.intro, { n: n, m: m });
    var hsh = location.hash.match(/#lieu=([a-z0-9-]+)/);
    renderAll();
    if (hsh && (byId[hsh[1]] || isWorkshop(hsh[1]))) { select(hsh[1], { silent: true }); renderAll(); }
  }

  var get = function (u) { return fetch(u).then(function (r) { return r.json(); }); };
  get(root.getAttribute('data-ui')).then(function (ui) {
    U = ui; buildShell(); bindShell();
    return get(root.getAttribute('data-map')).then(function (map) { M = map; buildMap(); })
      .then(function () { return get(root.getAttribute('data-places')); })
      .then(function (data) { D = data; start(); });
  }).catch(function () { app.appendChild(h('p', { class: 'kc-error' }, [(U && U.load_error) || root.getAttribute('data-error') || ''])); });
})();
